export default {
  DOWNLOAD: 'Download',
  OPEN_APP: 'Open App',
  CLICK_TOP_RIGHT_CORNER: 'Click the upper right corner',
  SELECT_OPEN_IN_BROWSER: 'Choose to open in browser'
};
